// IMPORTS
import _ from 'lodash'
import axios from 'axios'
import mobiscroll from '@mobiscroll/javascript'

// DEFINITIONS
const portabilidadAPI = 'portabilidad/process/web'

const state = {

}

const getters = {

}

const mutations = {
	
}

const actions = {
	portabilidadProcess: async ({}, data2send) => {
        try {
            let response = await axios.post(portabilidadAPI, data2send, { withCredentials: false });
            // ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
            if (response.msg) {
                mobiscroll.snackbar({
                    display: 'top',
                    theme: 'ios',
                    message: response.msg,
                    color: response.class,
                    duration: 7000
                })
            }
            return response.status
        } catch (e) {
            console.error(e)
            mobiscroll.snackbar({
                display: 'top',
                theme: 'ios',
                message: 'Ocurrió un error obteniendo la respuesta: ' + e,
                color: 'warning',
                duration: 7000
            })
            return false
        }
    }
}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
};